// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.s3OwrAzl29m0S8GZire8 {
  height: auto;
  display: flex;
  background-color: var(--md-grey-color);
  flex-direction: column;
  overflow: hidden;
}

.FIE64NVuVY8OXRBAi1AX {
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--white-color);
  background-color: var(--topic-color);

  flex-direction: column;
}

.FIE64NVuVY8OXRBAi1AX h1 {
  font-size: var(--step-3);
}

.lnv5wWDNta5VbmoPw2Gu {
  width: 80%;
}

.lnv5wWDNta5VbmoPw2Gu p {
  font-size: var(--step-1);
  line-height: var(--base-line-height);
}

.WKL96dwaRD4KAArbbDrV p {
  font-size: var(--step-1);
  line-height: var(--base-line-height);
}

.WKL96dwaRD4KAArbbDrV {
  margin-top: 2rem;
  width: 80%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-bottom: 2rem;
}

.mpVRoW_ghPYKq5Mc0uGr {
  color: var(--white-color);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

._TzLPizDf87vRkdMsl7r {
  background-color: var(--primary-color);
  height: 5rem;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

._4CIr8MeEqdFQA1RCkb0 {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 90vw;
  gap: var(--space-xs);
}

.pUvhHrnzFj1le1wbYeAP {
  padding-bottom: 2rem;
  padding-top: 4rem;
}

@media screen and (min-width: 1024px) {
  .FIE64NVuVY8OXRBAi1AX {
    flex-direction: row;
    padding-bottom: 5rem;
  }

  .WKL96dwaRD4KAArbbDrV {
    width: 50%;
    padding-right: 3rem;
  }

  .lnv5wWDNta5VbmoPw2Gu {
    display: flex;
    flex-direction: column;
    width: 50%;
    justify-content: center;
    padding-left: 5rem;
  }

  .lnv5wWDNta5VbmoPw2Gu p {
    max-width: 70%;
  }

  .WKL96dwaRD4KAArbbDrV p {
    max-width: 70%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/AllTopicsPage/AllTopicsPage.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,sCAAsC;EACtC,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,oCAAoC;;EAEpC,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,wBAAwB;EACxB,oCAAoC;AACtC;;AAEA;EACE,wBAAwB;EACxB,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;EACtC,YAAY;EACZ,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,UAAU;IACV,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,UAAU;IACV,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;AACF","sourcesContent":[".allTopicsPage {\n  height: auto;\n  display: flex;\n  background-color: var(--md-grey-color);\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.aboutSection {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--white-color);\n  background-color: var(--topic-color);\n\n  flex-direction: column;\n}\n\n.aboutSection h1 {\n  font-size: var(--step-3);\n}\n\n.topAbout {\n  width: 80%;\n}\n\n.topAbout p {\n  font-size: var(--step-1);\n  line-height: var(--base-line-height);\n}\n\n.bottomAbout p {\n  font-size: var(--step-1);\n  line-height: var(--base-line-height);\n}\n\n.bottomAbout {\n  margin-top: 2rem;\n  width: 80%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding-bottom: 2rem;\n}\n\n.pillLinkSection {\n  color: var(--white-color);\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.pillSearchBar {\n  background-color: var(--primary-color);\n  height: 5rem;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.keywordGroup {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  width: 90vw;\n  gap: var(--space-xs);\n}\n\n.topicLink {\n  padding-bottom: 2rem;\n  padding-top: 4rem;\n}\n\n@media screen and (min-width: 1024px) {\n  .aboutSection {\n    flex-direction: row;\n    padding-bottom: 5rem;\n  }\n\n  .bottomAbout {\n    width: 50%;\n    padding-right: 3rem;\n  }\n\n  .topAbout {\n    display: flex;\n    flex-direction: column;\n    width: 50%;\n    justify-content: center;\n    padding-left: 5rem;\n  }\n\n  .topAbout p {\n    max-width: 70%;\n  }\n\n  .bottomAbout p {\n    max-width: 70%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"allTopicsPage": `s3OwrAzl29m0S8GZire8`,
	"aboutSection": `FIE64NVuVY8OXRBAi1AX`,
	"topAbout": `lnv5wWDNta5VbmoPw2Gu`,
	"bottomAbout": `WKL96dwaRD4KAArbbDrV`,
	"pillLinkSection": `mpVRoW_ghPYKq5Mc0uGr`,
	"pillSearchBar": `_TzLPizDf87vRkdMsl7r`,
	"keywordGroup": `_4CIr8MeEqdFQA1RCkb0`,
	"topicLink": `pUvhHrnzFj1le1wbYeAP`
};
export default ___CSS_LOADER_EXPORT___;
